module.exports = __webpack_public_path__ + "img/wifi-eth-label.dbfa78b5.svg";